var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 15 5 L 15 15 L 5 15 L 5 17 L 15 17 L 15 27 L 17 27 L 17 17 L 27 17 L 27 15 L 17 15 L 17 5 Z","fill":"#000000"}));
}

Plus.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000"};

module.exports = Plus;

Plus.default = Plus;
